import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
	getFetchStateDefaultValue,
	handleFailureCase,
	handleRequestCase,
	handleSuccessCase,
} from "State/Utils";
import {
	getInvoicesUserReceivedInvoicesISDOCPdfsAvailableYears,
	GetUserReceivedInvoicesAvailableYearsQueryResult,
} from "Api/Api";

export const getUserReceivedInvoicesAvailableYearsAsync = createAsyncAction(
	"@invoice/GET_AVAILABLE_YEARS_RECEIVED_REQUEST",
	"@invoice/GET_AVAILABLE_YEARS_RECEIVED_RESPONSE",
	"@invoice/GET_AVAILABLE_YEARS_RECEIVED_FAILURE",
)<void, GetUserReceivedInvoicesAvailableYearsQueryResult, Error>();

function* getUserReceivedInvoicesAvailableYears(): Generator {
	try {
		const { data, error, status } = yield* call(
			getInvoicesUserReceivedInvoicesISDOCPdfsAvailableYears,
		);

		if (status === 200) {
			yield put(getUserReceivedInvoicesAvailableYearsAsync.success(data));
			return;
		}

		yield put(
			getUserReceivedInvoicesAvailableYearsAsync.failure(
				mapAPIErrorResponse(error ?? data),
			),
		);
	} catch (err) {
		yield put(getUserReceivedInvoicesAvailableYearsAsync.failure(err as Error));
	}
}

export function* getUserReceivedInvoicesAvailableYearsSaga() {
	yield takeLatest(
		getType(getUserReceivedInvoicesAvailableYearsAsync.request),
		getUserReceivedInvoicesAvailableYears,
	);
}

export const getUserReceivedInvoicesAvailableYearsSlice = createSlice({
	initialState:
		getFetchStateDefaultValue<GetUserReceivedInvoicesAvailableYearsQueryResult>(
			false,
		),
	name: "@invoice/getUserReceivedInvoicesAvailableYears",
	reducers: {},
	extraReducers: builder => {
		handleRequestCase(getUserReceivedInvoicesAvailableYearsAsync, builder);
		handleSuccessCase(getUserReceivedInvoicesAvailableYearsAsync, builder);
		handleFailureCase(getUserReceivedInvoicesAvailableYearsAsync, builder);
	},
});
